// TennisTrack Hub — Navbar v2.0 | 029 Project
// Logo grande al centro, nav links ai lati, Medical Network aggiunto
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PannelloNotifiche from './PannelloNotifiche';
import './Navbar.css';

const Navbar = () => {
  const { utente, logout } = useAuth();
  const location = useLocation();
  const [menuAperto, setMenuAperto] = useState(false);
  const [mobileMenuAperto, setMobileMenuAperto] = useState(false);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <>
      {/* ── NAVBAR DESKTOP ── */}
      <nav className="navbar">
        {/* Colonna sinistra: link navigazione */}
        <div className="navbar-left">
          <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
            🏠 Dashboard
          </Link>
          <Link to="/atleti" className={`nav-link ${isActive('/atleti') ? 'active' : ''}`}>
            🎾 Atleti
          </Link>
          <Link to="/template" className={`nav-link ${isActive('/template') ? 'active' : ''}`}>
            📋 Template
          </Link>
        </div>

        {/* Centro: Logo grande */}
        <div className="navbar-center">
          <Link to="/dashboard" className="navbar-brand">
            <img src="/img/logo_tennistrack_300x800.png" alt="TennisTrack Hub" className="navbar-logo" />
          </Link>
        </div>

        {/* Colonna destra: Medical + Pro + User */}
        <div className="navbar-right">
          <Link to="/medici" className={`nav-link nav-link-medical ${isActive('/medici') ? 'active' : ''}`}>
            🩺 Medical
          </Link>
          {utente?.piano !== 'pro' && (
            <Link to="/premium" className={`nav-link nav-link-pro ${isActive('/premium') ? 'active' : ''}`}>
              ⭐ Pro
            </Link>
          )}

          {/* Notifiche */}
          <PannelloNotifiche />

          {/* Badge piano */}
          <Link
            to="/premium"
            className={`piano-badge piano-${utente?.piano}`}
            title={utente?.piano !== 'pro' ? 'Fai upgrade a Pro' : 'Piano Pro attivo'}
            style={{ textDecoration: 'none' }}
          >
            {utente?.piano === 'pro' ? '⭐ PRO' : utente?.piano?.toUpperCase()}
          </Link>

          {/* Avatar + Dropdown */}
          <div className="navbar-avatar-wrap">
            <div className="navbar-avatar" onClick={() => setMenuAperto(!menuAperto)}>
              {utente?.nome?.[0]}{utente?.cognome?.[0]}
            </div>

            {menuAperto && (
              <div className="navbar-dropdown" onClick={() => setMenuAperto(false)}>
                <div className="dropdown-info">
                  <strong>{utente?.nome} {utente?.cognome}</strong>
                  <span>{utente?.email}</span>
                </div>
                <hr />
                <Link to="/profilo" className="dropdown-link">
                  👤 Il mio profilo
                </Link>
                {utente?.piano !== 'pro' && (
                  <Link to="/premium" className="dropdown-upgrade-link">
                    ⭐ Passa a Pro
                  </Link>
                )}
                <Link to="/admin" className="dropdown-link dropdown-link-admin">
                  🛠 Admin
                </Link>
                <hr />
                <button onClick={logout} className="dropdown-btn-logout">🚪 Esci</button>
              </div>
            )}
          </div>
        </div>

        {/* Hamburger solo mobile */}
        <button
          className="navbar-hamburger"
          onClick={() => setMobileMenuAperto(!mobileMenuAperto)}
          aria-label="Menu"
        >
          {mobileMenuAperto ? '✕' : '☰'}
        </button>
      </nav>

      {/* ── MOBILE MENU DRAWER ── */}
      {mobileMenuAperto && (
        <div className="mobile-menu" onClick={() => setMobileMenuAperto(false)}>
          <div className="mobile-menu-header">
            <img src="/img/logo_tennistrack_300x800.png" alt="TennisTrack Hub" className="mobile-logo" />
          </div>
          <div className="mobile-menu-user">
            <div className="mobile-avatar">{utente?.nome?.[0]}{utente?.cognome?.[0]}</div>
            <div>
              <div className="mobile-user-name">{utente?.nome} {utente?.cognome}</div>
              <div className="mobile-user-email">{utente?.email}</div>
            </div>
          </div>
          <nav className="mobile-nav">
            <Link to="/dashboard" className="mobile-nav-link">🏠 Dashboard</Link>
            <Link to="/atleti"    className="mobile-nav-link">🎾 Atleti</Link>
            <Link to="/template"  className="mobile-nav-link">📋 Template</Link>
            <Link to="/medici"    className="mobile-nav-link mobile-nav-link-medical">🩺 Medical Network</Link>
            {utente?.piano !== 'pro' && (
              <Link to="/premium" className="mobile-nav-link mobile-nav-link-pro">⭐ Passa a Pro</Link>
            )}
            <Link to="/profilo"   className="mobile-nav-link">👤 Profilo</Link>
            <Link to="/admin"     className="mobile-nav-link mobile-nav-link-admin">🛠 Admin</Link>
            <button onClick={() => { logout(); setMobileMenuAperto(false); }} className="mobile-btn-logout">
              🚪 Esci
            </button>
          </nav>
        </div>
      )}

      {/* Overlay chiudi dropdown desktop */}
      {menuAperto && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 199 }}
          onClick={() => setMenuAperto(false)}
        />
      )}
    </>
  );
};

export default Navbar;
